/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
import BootstrapVue3 from 'bootstrap-vue-3';
import VueObserveVisibility from 'vue-observe-visibility';

window.Vue = require('vue').default;

import { createApp, h } from "vue";
import router from './router';
import { store } from './store';

const app = createApp({})
  
app.use(router);
app.use(store);
app.use(BootstrapVue3);
app.use(VueObserveVisibility);


app.component('iq-card', require('./components/custom/cards/iq-card').default)
// app.component('loader', require('./components/custom/loader/Loader').default)
// app.component('alert', require('./components/bootstrap/alert/alert').default)
// app.component('carousel', require('./components/bootstrap/carousel/carousel').default)
// app.component('carouselItems', require('./components/bootstrap/carousel/carouselItems').default)
// app.component('toast', require('./components/bootstrap/toasts/toast').default)
// app.component('toast-header', require('./components/bootstrap/toasts/toast-header').default)
// app.component('toast-body', require('./components/bootstrap/toasts/toast-body').default)
// app.component('progressbar', require('./components/bootstrap/Progressbar/progressbar').default)
// app.component('popover', require('./components/bootstrap/popover/popover').default)
app.component('tooltip', require('./components/bootstrap/tooltip/tooltip').default)
// // app.component('Lottie', require('./components/socialapp/lottie/Lottie').default)
app.component('tab-nav', require('./components/bootstrap/tab/tab-nav').default)
app.component('tab-nav-items', require('./components/bootstrap/tab/tab-nav-items').default)
app.component('tab-content', require('./components/bootstrap/tab/tab-content').default)
app.component('tab-content-item', require('./components/bootstrap/tab/tab-content-item').default)
// app.component('TimeLine', require('./components/custom/timeline/TimeLine').default)
app.component('dropdown', require('./components/bootstrap/dropdown/dropdown').default) 
app.component('dropdown-items', require('./components/bootstrap/dropdown/dropdown-items').default)
// app.component('collapse', require('./components/bootstrap/collapse/collapse').default)
// app.component('collapse-content', require('./components/bootstrap/collapse/collapse-content').default)
//app.component('modal', require('./components/bootstrap/modal/modal').default)
//app.component('modal-header', require('./components/bootstrap/modal/modal-header').default)
//app.component('modal-body', require('./components/bootstrap/modal/modal-body').default)
//app.component('modal-footer', require('./components/bootstrap/modal/modal-footer').default)
// app.component('offcanvas', require('./components/bootstrap/offcanvas/offcanvas').default)
// app.component('offcanvas-header', require('./components/bootstrap/offcanvas/offcanvas-header').default)
// app.component('offcanvas-body', require('./components/bootstrap/offcanvas/offcanvas-body').default)

export default app;
